import { render, staticRenderFns } from "./LinePay.vue?vue&type=template&id=164f149e&scoped=true&"
import script from "./LinePay.vue?vue&type=script&lang=js&"
export * from "./LinePay.vue?vue&type=script&lang=js&"
import style0 from "./LinePay.vue?vue&type=style&index=0&id=164f149e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f149e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard,VCardText})
